import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  columns,
  fetchData,
  paginationData,
  summary,
}) {
  const [tableData, setTableData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const pageSize = paginationData.limit || 10;

  useEffect(() => {
    setTableData(paginationData.data || []);
  }, [paginationData.data]);

  const handleRowsPerPageChange = (newLimit) => {
    fetchData(
      1,
      month || undefined,
      year || undefined,
      search,
      newLimit,
      fromDate || undefined,
      toDate || undefined,
    );
  };

  const handlePageChange = (page) => {
    fetchData(
      page,
      month || undefined,
      year || undefined,
      search,
      pageSize,
      fromDate || undefined,
      toDate || undefined,
    );
  };

  const applyFilters = () => {
    setShowFilterModal(false);

    fetchData(
      1,
      month || undefined,
      year || undefined,
      search,
      pageSize,
      fromDate || undefined,
      toDate || undefined,
    );
  };

  const removeFilters = () => {
    setMonth("");
    setYear("");
    setSearch("");
    setFromDate("");
    setToDate("");
    setShowFilterModal(false);

    fetchData(1);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-3">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search Date (DD-MM-YYYY)"
            value={search}
            onChange={(e) => {
              const value = e.target.value;
              setSearch(value);

              // Allow only DD-MM-YYYY or DD/MM/YYYY
              const regex = /^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/;

              if (regex.test(value.trim())) {
                const separator = value.includes("/") ? "/" : "-";

                const [day, month, year] = value.split(separator);

                const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

                // Update filter states
                setFromDate(formattedDate);
                setToDate(formattedDate);

                fetchData(
                  1,
                  undefined,
                  undefined,
                  "",
                  pageSize,
                  formattedDate,
                  formattedDate,
                );
              } else if (value.trim() === "") {
                // Clear search -> back to normal month/year filter
                setFromDate("");
                setToDate("");

                fetchData(
                  1,
                  month || undefined,
                  year || undefined,
                  "",
                  pageSize,
                );
              }
            }}
          />
        </div>

        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary me-2 mb-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>

          <button className="btn btn-success me-2 mb-2">
            Trips : {(summary?.trips || 0).toLocaleString()}
          </button>

          <button className="btn btn-info me-2 mb-2">
            Revenue : ₹{Number(summary?.revenue || 0).toLocaleString()}
          </button>

          <button className="btn btn-warning me-2 mb-2">
            Lease : ₹{Number(summary?.lease || 0).toLocaleString()}
          </button>

          <button className="btn btn-secondary me-2 mb-2">
            Expense : ₹{Number(summary?.totalExpense || 0).toLocaleString()}
          </button>

          <button className="btn btn-dark me-2 mb-2">
            Profit : ₹{Number(summary?.profit || 0).toLocaleString()}
          </button>

          <button className="btn btn-danger me-2 mb-2">
            Loss : ₹{Number(summary?.loss || 0).toLocaleString()}
          </button>

          <button
            className={`btn me-2 mb-2 ${
              Number(summary?.netPL || 0) >= 0 ? "btn-success" : "btn-danger"
            }`}
          >
            P/L : {Number(summary?.netPL || 0) < 0 ? "-" : ""}₹
            {Math.abs(Number(summary?.netPL || 0)).toLocaleString()}
          </button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={tableData}
        pagination
        paginationServer
        paginationPerPage={pageSize}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationTotalRows={paginationData.totalClients || 0}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        month={month}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
      />
    </div>
  );
}
